<template>
  <modal
    name="giftingPointsModal"
    modal-style="compact"
  >
    <gift-loyalty-points />
  </modal>
</template>


<script>
  import GiftLoyaltyPoints from './gift-loyalty-points/index.vue';


  export default {
    name: 'GiftLoyaltyPointsModal',

    components: {
      GiftLoyaltyPoints
    }
  };
</script>
